var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg46(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1121_7589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1663 3.8335H3.83301V42.1668H42.1663V3.8335Z",
    fill: "#0091D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83301 3.8335L13.4135 13.4196L22.9997 3.8335H3.83301Z",
    fill: "#0091D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83301 3.8335V23.0002L13.4135 13.4196L3.83301 3.8335Z",
    fill: "#009AD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9997 23.0002L13.4191 13.4141L3.83301 23.0002H22.9997Z",
    fill: "#0091D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9995 23.0002V3.8335L13.4189 13.414L22.9995 23.0002Z",
    fill: "#0082C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 3.8335V23.0002L32.5805 13.4196L23 3.8335Z",
    fill: "#0071BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1667 23.0002L32.5861 13.4141L23 23.0002H42.1667Z",
    fill: "#004C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83301 23L13.4135 32.5861L22.9997 23H3.83301Z",
    fill: "#0082C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83301 23V42.1667L13.4135 32.5861L3.83301 23Z",
    fill: "#0071BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9997 42.1667L13.4191 32.5806L3.83301 42.1667H22.9997Z",
    fill: "#0066B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9995 42.1667V23L13.4189 32.5805L22.9995 42.1667Z",
    fill: "#00529C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 23L32.5805 32.5861L42.1667 23H23Z",
    fill: "#1B3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 23V42.1667L32.5805 32.5861L23 23Z",
    fill: "#004C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1667 42.1667L32.5861 32.5806L23 42.1667H42.1667Z",
    fill: "#1B3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1665 42.1667V23L32.5859 32.5805L42.1665 42.1667Z",
    fill: "#1B3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 3.8335L32.5805 13.4196L42.1667 3.8335H23Z",
    fill: "#0066B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1665 23.0002V3.8335L32.5859 13.414L42.1665 23.0002Z",
    fill: "#00529C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1659 27.7933L29.8921 16.1074L11.2686 34.7757L18.0606 41.5678L29.8921 29.9211L42.1659 42.1277V27.7933Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1121_7589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.3333,
    height: 38.3333,
    fill: "white",
    transform: "translate(3.83301 3.8335)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg46);
export default __webpack_public_path__ + "static/media/광주-46.2adfea27637b9ebadbd4aa8056dafbfd.svg";
export { ForwardRef as ReactComponent };